import {
  RegisterPolicyDto,
  PolicyResponse
} from '../components/common/CommonTypes';
import { ApiHelper } from './apiHelper';

/**
 * Client-side API wrapper for policy registration endpoints.
 */
export class PolicyApi {
  /**
   * Registers a policy.
   *
   * @param registerPolicyDto Policy registration payload.
   * @param token Bearer token used for authenticated requests.
   * @param successCallback Invoked with policy response data on success.
   * @param failureCallback Invoked when the request fails.
   * @param signal Abort signal used to cancel the request.
   */
  register(
    registerPolicyDto: RegisterPolicyDto,
    token: string,
    successCallback: (policyResponse: PolicyResponse[]) => void,
    failureCallback: () => void,
    signal: AbortSignal
  ): void {
    const url = `/api/policy`;
    console.log(registerPolicyDto.policy);

    new ApiHelper().postDataSecureAsync(
      url,
      registerPolicyDto,
      token,
      successCallback,
      failureCallback,
      signal
    );
  }
}
